export default __webpack_public_path__ + "static/media/icon-user.9193b08c.svg";